// Copyright (c) 2016 Deere & Company

import Tab from '../../../../src/shared/state/tab';

export const getNavigationTabs = (countObject, hasSearchResults, showDealerInvoice) => {

    const navigationTabs = [
        new Tab({
            count: countObject.allClaims,
            label: 'CLAIMS_OVERVIEW_TAB',
            route: '/claims/all'
        })
    ];

    if (showDealerInvoice) {

        navigationTabs.push(new Tab({
            count: countObject.dealerInvoices,
            label: 'WAITING_FOR_INVOICE',
            route: '/claims/dealer-invoices'
        }));

    }

    if (hasSearchResults) {

        navigationTabs.push(new Tab({
            count: countObject.claimSearch,
            label: 'SEARCH_RESULTS_TAB',
            route: '/claims/search'
        }));

    }

    return navigationTabs;

};



// WEBPACK FOOTER //
// ./src/claim/shared/services/claim-navigation-helper.js